<template>
  <div class="distribuir-conceito">
    <BuscaAnoNivelEtapaDisciplina @chosen="exibirConceito" @reloading="isReload"/>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;" class="mt-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <transition name="router-lancar-conceito" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-if="form.identificadorgrupoconceito > 0 && periodosAvaliativos.length > 0 && exibirGeral">
        <v-card class="pa-3 mt-3">
          <Validator label="Períodos Avaliativos" block style="width: 100%">
            <div v-for="periodo in periodosAvaliativos" :key="periodo.id" style="flex: 1; text-align:center" >
              <CheckBox
                v-model="form.cdpravadi"
                :label="periodo.dspravadi"
                :val="periodo.cdpravadi"
                :disabled="!buscadoDistribuir || insertLoading"
                @input="exibirConceito(null)" />
            </div>
          </Validator>

          <div><strong>Atividade Distribuidas</strong></div>
          <div v-if="atividadesDistribuidas.length <= 0">Nenhuma Atividade Cadastrada</div>
          <table v-else class="table-siged">
            <thead>
              <tr>
                <th style="width: 55%">Atividade</th>
                <th style="width: 15%">Etapa</th>
                <th style="width: 15%">Período(s)</th>
                <th style="width: 15%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="atividade in atividadesDistribuidas" :key="atividade.id">
                <td>{{ atividade.descricaoatividadeavaliativa }}</td>
                <td class="centro">{{ atividade.etapa_escolar.dsserie }}</td>
                <td class="centro">{{ montarPeriodo(atividade.periodos) }}</td>
                <td class="centro">{{ atividade.identificadordistribuirconceit }}
                  <span v-if="form.cdserie && form.cdserie.length > 1"><v-icon>remove</v-icon></span> <!-- ATIV. APLICADA A TODAS ETAPAS -->
                  <v-btn v-else icon title="Excluir" class="aulas-btn-acao" @click="removerAtividade(atividade.idsDistribuir)" :disabled="!buscadoDistribuir">
                    <v-icon color="red">delete_forever</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>

        <v-card class="pa-3 mt-3">
          <Input label="Buscar Atividade" v-model="buscaAtividade" @input="buscarAtividadeAvaliativa"/>
          <v-progress-linear :indeterminate="true" height="5" v-if="loadingSearch"></v-progress-linear>
          <div v-else-if="buscaAtividade !== '' && listaAtividadesEncontradas.length <= 0">
            <ul>
              <li>Nenhuma atividade encontrada</li>
            </ul>
          </div>
          <table v-else-if="buscaAtividade !== '' && listaAtividadesEncontradas.length > 0" class="table-siged">
            <thead>
              <tr>
                <th>Atividade</th>
                <th>Adicionar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(atividade, index) in listaAtividadesEncontradas" :key="atividade.id">
                <td>{{ atividade.descricaoatividadeavaliativa }}</td>
                <td class="centro">
                  <v-icon v-if="verificarAtividadeInserida(atividade.identificadoratividade)" color="green" title="Atividade já adicionada">check</v-icon>
                  <v-btn
                    v-else
                    icon
                    color="green"
                    title="Adicionar Atividade"
                    :disabled="form.cdpravadi.length <= 0 || !buscadoDistribuir"
                    @click="adicionarAtividade(atividade.identificadoratividade, index)"
                    :loading="atividade.loading">
                    <v-icon>add</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </div>
    </transition>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import BuscaAnoNivelEtapaDisciplina from '@/components/BuscaAnoNivelEtapaDisciplina';
import { required, integer } from 'vuelidate/lib/validators';

const DistribuirConceitoRepository = RepositoryFactory.get('distribuirConceito');
const AtividadeAvaliativaRepository = RepositoryFactory.get('atividadeAvaliativa');

const setFormInicial = () => ({
  aaletivo: '',
  cdinstruc: '',
  cdserie: '',
  cddiscipl: '',
  cdpravadi: [],
  identificadorgrupoconceito: '',
});

export default {
  name: 'DistribuirConceito',
  components: {
    BuscaAnoNivelEtapaDisciplina,
  },
  data() {
    return {
      msgArrayError: [],
      buscaAtividade: '',
      buscadoDistribuir: false,
      loadingSearch: false,
      listaAtividadesEncontradas: [],
      periodosAvaliativos: [],
      atividadesDistribuidas: [],
      typingTimeout: 0,
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      exibirGeral: false,
    };
  },
  validations: {
    form: {
      aaletivo: { required, integer },
      cdinstruc: { required, integer },
      cdserie: { required },
      cddiscipl: { integer },
      cdpravadi: { required },
      identificadorgrupoconceito: { required, integer },
    },
  },
  methods: {
    async exibirConceito(escolhas = null) {
      if(escolhas) { this.exibirGeral = false; }
      this.buscadoDistribuir = false;
      try {
        this.$Progress.start();
        this.$v.$reset();
        this.msgArrayError = [];

        const request = (!escolhas)? this.form : escolhas;

        const { data } = await DistribuirConceitoRepository.getDistribuirConceito(request);

        if(data.results.periodos.length <= 0) {
          this.msgArrayError.push('Nenhum período avaliativo encontrado!');
          return;
        }

        this.periodosAvaliativos = data.results.periodos;
        if(escolhas || this.form.cdpravadi.length <= 0) { this.form.cdpravadi = this.periodosAvaliativos.map(key => key.cdpravadi); }
        this.form = {
          ...this.form,
          ...escolhas,
          identificadorgrupoconceito: data.results.identificadorgrupoconceito
        };

        this.atividadesDistribuidas = data.results.atividadesDistribuidas;
      } catch(error) {
        if (error.response.data.status == 'ERROR_CONCEPT_GROUP') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.buscadoDistribuir = true;
        this.$Progress.finish();
        setTimeout(() => this.exibirGeral = true, 400);
      }
    },
    buscarAtividadeAvaliativa() {
      if(this.typingTimeout) { clearTimeout(this.typingTimeout); }

      if(this.buscaAtividade === '') {
        this.loadingSearch = false;
        return;
      }

      this.loadingSearch = true;
      this.typingTimeout = setTimeout(async () => {
        try {
          const { data } = await AtividadeAvaliativaRepository.getAtividadeAvaliativa({
            descricaoatividadeavaliativa: this.buscaAtividade,
            indicaformaavaliacao: 'QL',
          });

          this.listaAtividadesEncontradas = data.results.map(key => ({
            loading: false,
            ...key,
          }));
        } finally {
          this.loadingSearch = false;
        }
      }, 500);
    },
    async adicionarAtividade(id, index) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }

      try {
        this.listaAtividadesEncontradas[index].loading = true;
        const { data } = await DistribuirConceitoRepository.postDistribuirConceito({
          ...this.form,
          identificadoratividade: id,
        });

        await this.exibirConceito(null);

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.listaAtividadesEncontradas[index].loading = false;
        this.$v.$reset();
      }
    },
    async removerAtividade(ids) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta atividade?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if(!confirmar) { return; }

      this.buscadoDistribuir = false;
      try {
        const { data } = await DistribuirConceitoRepository.deleteDistribuirConceito({
          identificadordistribuirconceit: ids,
        });

        await this.exibirConceito(null);

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
      } catch(error) {
        if (error.response.data.errorMessage) { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.buscadoDistribuir = true;
        this.$v.$reset();
      }
    },
    montarPeriodo(periodos) {
      let texto = '';
      for(const periodo of periodos) {
        const index = this.periodosAvaliativos.findIndex(key => key.cdpravadi === periodo)
        if(index >= 0) { texto += `${this.periodosAvaliativos[index].dspravadi}, `; }
      }
      return texto.substring(0, texto.length-2);
    },
    verificarAtividadeInserida(id) {
      return this.form.cdserie.every(n => {
        const index = this.atividadesDistribuidas.findIndex(key => key.identificadoratividade === id && key.cdserie == n);
        if(index >= 0) {
          return this.form.cdpravadi.every(key => this.atividadesDistribuidas[index].periodos.indexOf(key) >= 0);
        }
        return false;
      });
    },
    isReload() {
      this.exibirGeral = false;
      this.msgArrayError = [];
    }
  },
  computed: {
    insertLoading() {
      return this.listaAtividadesEncontradas.some(key => key.loading === true);
    }
  }
}
</script>

<style lang="scss">
.distribuir-conceito {
  margin: 13px 15px;
}
</style>
